module.exports = __webpack_public_path__ + "static/img/car_maintaining.9.bffd108c.png";